module.exports = __webpack_public_path__ + "static/media/CutAndStyle.e98cc0f9.jpg";